import { HubClient } from '@verybigthings/trackframe-hub-client';

// Hub origin — where every API + cookie call goes. Three lookup steps so the
// SPA works in every deployment shape without a per-env build:
//
//   1. `window.__APP_CONFIG__.hubBaseUrl` (runtime, injected by the hub into
//      index.html). Production path — one Docker image, env-specific hub URL
//      baked into the served HTML at boot.
//   2. `VITE_HUB_URL` (build-time env var) — local dev with Caddy: `tf.com`
//      is the SPA origin, `api.tf.com` is the API. Setting
//      `VITE_HUB_URL=http://api.tf.com` makes the Vite dev server's SPA call
//      the hub directly so cookies land on api.tf.com / .tf.com.
//   3. Fallback: same-origin (`window.location.origin`). Single-origin
//      deployments where the hub serves the SPA from its own host.
const RUNTIME_HUB_URL =
  typeof window !== 'undefined' ? window.__APP_CONFIG__?.hubBaseUrl : undefined;
const BUILD_HUB_URL =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_HUB_URL) || undefined;
const RAW_HUB_URL = RUNTIME_HUB_URL || BUILD_HUB_URL || undefined;
export const hubBaseUrl = (
  RAW_HUB_URL ?? (typeof window !== 'undefined' ? window.location.origin : '')
).replace(/\/+$/, '');

// True when the SPA and hub are different origins — required for the browser
// to attach cookies on cross-origin XHR (`credentials: 'include'`). On
// same-origin the default behavior already attaches them.
const SPA_ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
const isCrossOrigin = Boolean(hubBaseUrl) && hubBaseUrl !== SPA_ORIGIN;

// Singleton client. `credentials: 'include'` is set only when the hub is on
// a different origin — necessary for the cookies to flow cross-origin.
// Same-origin deploys don't need it (browser default `same-origin` already
// attaches cookies).
export const hub = new HubClient({
  baseUrl: hubBaseUrl,
  credentials: isCrossOrigin ? 'include' : undefined,
  autoRefresh: true,
});
